import React, {Fragment} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import QuotesSwitcherListQuotes from "./quotesSwitcherListQuotes";
import QuotesSwitcherListCategories from "./quotesSwitcherListCategories";
import WithAddToQuote from "../../../hocs/withAddToQuote";
import {
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType
} from "../../../../../actions/sqftMenuFunctions";

const QuotesSwitcherLists = (props) => {
  const {quotes} = props
  const {baseClass, handleDropDownClick} = props
  const visibleQuotes = quotes.filter(quote => quote.isVisibleInSQFT !== false);

  return (
    <ul className={baseClass+"__dropdown-list"}>
      <WithAddToQuote props={props}>
        {(handleAddToQuoteClick, prepareSQFTData) => (
          <Fragment>
            <QuotesSwitcherListQuotes baseClass={baseClass}
                                      startIndex={0}
                                      handleDropDownClick={handleDropDownClick}
                                      prepareSQFTData={prepareSQFTData} />
            <QuotesSwitcherListCategories baseClass={baseClass}
                                          handleDropDownClick={handleDropDownClick}
                                          startIndex={visibleQuotes.length ? visibleQuotes.length : 0}
                                          prepareSQFTData={prepareSQFTData} />
          </Fragment>
        )}
      </WithAddToQuote>
    </ul>
  )
}

QuotesSwitcherLists.propTypes = {
  baseClass: PropTypes.string.isRequired,
  handleDropDownClick: PropTypes.func,
};

const mapStateToProps = (store) => ({
  quotes: store.quotesState.quotes,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
})

const mapDispatchToProps = {
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType,
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotesSwitcherLists)
